module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTBZq9hRo9xVr9Rds9Q1k+hds9hZr9RVq9A9n9BZs9hRs9BVr9BVr9RJo9hZr9hZr9RZr9RVr9RRq9RVq9RJr9hdr9QilClsAAAAWdFJOUwC5N5TrDfjWWRW+PHdrIabizZxMfkT6U3pDAAAAxklEQVQoz82R2Q6EIAxFixSwLiwu/P+njlIcUckk8zDJnKfbnDTpAvA9im41k6vV66mQrUEm2L2ctZHavS3pIBkUyQaC8fRNbHMSJlso/EX3bHc/VbTzx9RLtE8tscnLCFRPTYG9Enqsjcb+tDedfGG3vbshsaS9gQyaOBZX8zGh+WpAUzdfX8DUH9QIkwhSATnOxtmjF33HbIfqMGcMlckVyuNomj7pIf6/ttG1jAngQ87HuwFkzOAKrc75fBnYnqEiW/g5L7GDDaxDIf6pAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/more5.png
// module id = PtTK
// module chunks = 0